import config from 'react-global-configuration';
import {
  setOperationStatus,
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';

export const webformSubmit = (id, values, options = {}) => {
  const defaultOptions = {
    method: 'POST',
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
  }

  const uppercaseMethod = mergedOptions.method.toUpperCase();

  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    // Replace the 'other' options with the actual value.
    Object.keys(values).forEach((key) => {
      if (values[key] === '__other__') {
        values[key] = values[`${key}--other`];
      }
    });

    setOperationStatus('webform', 'submit', UI_OPERATION_STATUS_REQUEST);

    if (uppercaseMethod === 'PATCH' && !mergedOptions.uuid) {
      console.warn('Executing a PATCH on a webform requires a uuid option.')
    }

    const url = uppercaseMethod === 'POST' ? `${PATH}/webform_rest/submit` : `${PATH}/webform_rest/${id}/submission/${mergedOptions.uuid}`;

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((csrfToken) => fetch(url, {
          method: uppercaseMethod,
          credentials: 'include',
          body: JSON.stringify({
            webform_id: id,
            ...values,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        }))
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }

          return response.json();
        })
        .then((responsePayload) => {
          dispatch(setOperationStatus('webform', 'submit', UI_OPERATION_STATUS_SUCCESS));
          dispatch(webformSuccesfulSubmit(id));
          resolve(responsePayload);
        })
        .catch((err) => {
          dispatch(setOperationStatus('webform', 'submit', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
};

export const WEBFORM_UNLOAD = 'WEBFORM_UNLOAD';
export function webformUnload() {
  return {
    type: WEBFORM_UNLOAD,
  };
};

export const WEBFORM_SUCCESSFUL_SUBMIT = 'WEBFORM_SUCCESSFUL_SUBMIT';
export function webformSuccesfulSubmit(id) {
  return {
    type: WEBFORM_SUCCESSFUL_SUBMIT,
    payload: {
      id,
    },
  };
};
